import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { Checkbox } from 'antd';
import { IModifiersContext, ModifiersContext } from '../../../modifiersState/modifiersContext';

const ModifiersInStopCheckBox: React.FC = () => {
	const { toggleIsDisabledModifiers, IDSelectedCustomer, IDSelectedRestaurant, isDisabledModifier } =
		useContext<IModifiersContext>(ModifiersContext);

	return (
		<Checkbox
			checked={isDisabledModifier}
			onChange={toggleIsDisabledModifiers}
			disabled={!IDSelectedCustomer || !IDSelectedRestaurant}
			data-test="DisabledModifiersCheckBox">
			<Text translationNameSpace="listing" translationKey="modifierInStopLabel" asFragment={true} />
		</Checkbox>
	);
};

export default ModifiersInStopCheckBox;
